import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaPixelPageView } from '@/lib/ads/metaPixel';

const describePageCategory = (pathname: string): string => {
  if (pathname.startsWith('/c/')) {
    return 'challenge';
  }

  if (pathname.startsWith('/sign-in')) {
    return 'auth_sign_in';
  }

  if (pathname.startsWith('/sign-up')) {
    return 'auth_sign_up';
  }

  if (pathname.startsWith('/play')) {
    return 'play';
  }

  if (pathname === '/') {
    return 'landing';
  }

  return 'site';
};

const MetaPixelRouteTracker = (): null => {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    const pageCategory = describePageCategory(location.pathname);

    trackMetaPixelPageView({
      page_category: pageCategory,
      page_path: pagePath,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelRouteTracker;
